// Bank Account Management Permissions

export const BANKS_INDEX = 32;
export const BANKS_CREATE = 33;
export const BANKS_EDIT = 34;
export const BANKS_DELETE = 35;
export const BANKS_RESTORE = 1395;
